import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { VideogularComponent } from '../videogular/Videogular.Component';

import { BannerHelper } from './BannerHelper';
import { IBanner } from './BannerTypes';

@Component({
	selector: 'vb-video-banners',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
		<div [ngClass]="['root', isSmallSizePlayer ? 'smallSizePlayer' : '']">
			@for (banner of bannerHelper.bannerDetails().banners; track banner) {
				@if (banner.isEnabled  && banner.pushMethod === 'Manual' && bannerHelper.closedBannerIds().indexOf(banner.id) === -1){
					<div class="bannerWrapper">
						<div class="closeBtnWrapper">
							<button
								type="button"
								class="btn float-right btn-transparent"
								[attr.aria-label]="translations.close"
								(click)="onCloseClick(banner)"
							>
								<span class="vb-icon vb-icon-close"></span>
							</button>
						</div>
						@if (banner.message) {
							<div class="message" [innerHTML]="banner.message"></div>
						}
						@if (banner.link) {
							<div class="linkWrapper">
								<a class="link" [href]="banner.link" target="_blank">{{ banner.link }}</a>
							</div>
						}
					</div>
				}
			}
		</div>
	`,
	standalone: false,
	styleUrls: ['./VbVideoBanners.Component.ng.less']
})
export class VbVideoBannersComponent {
	@Input() public isSmallSizePlayer: boolean;
	@Input() public bannerHelper: BannerHelper;
	@Input() public translations: any;

	constructor(
		public vgApi: VideogularComponent
	) { }

	public onCloseClick(banner: IBanner): void {
		this.bannerHelper.closeBanner(banner);
	}
}
